import { render, staticRenderFns } from "./GigDetails.htm?vue&type=template&id=cadde914&scoped=true&"
import script from "./GigDetails.ts?vue&type=script&lang=js&"
export * from "./GigDetails.ts?vue&type=script&lang=js&"
import style0 from "./GigDetails.scss?vue&type=style&index=0&id=cadde914&lang=scss&scoped=true&"
import style1 from "./GigDetailsLayout.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cadde914",
  null
  
)

export default component.exports